import DaoBase from "./base";
import DaoBBS from "./bbs";
import DaoBBSFile from "./bbs.file";
import DaoInformation from "./information";
import DaoChannel from "./channel";
import DaoChannelRecommand from "./channel.recommand";
import {rd} from "../../vars/rd";

class DaoMain extends DaoBase {
    version = new Date().getTime();

    /**
     * 상단 로고이미지
     * @type {{logo: string, profile: string, message: string} | null}
     */
    header;

    /**
     * 메인 왼쪽 상단 이미지
     * @type {{banner: string, message: string}}
     */
    left;

    /**
     * BBS
     * @type {DaoBBS[]}
     */
    bbs;

    /**
     * PD Pick!
     * @type {{title: string, text: string, lists: DaoChannel}[]}
     */
    pick;

    /**
     * 최근재생한 채널
     * @type DaoChannel[]
     */
    history;

    /**
     * 오늘의 맞춤 추천 채널
     * @type {{logo: string, name: string, message: string, lists: DaoChannelRecommand[]}}
     */
    channel;

    /**
     * 실시간 인기차트
     * @type {{all: DaoChannel[], biz: DaoChannel[]}}
     */
    chart;

    brandlogo = null;

    /**
     * 매장 정보
     * @type {DaoInformation}
     */
    information;


    constructor(json=null) {
        super(json);
    }

    /**
     *
     * @param json {*}
     * @returns {DaoMain}
     */
    setData(json) {
        if(json) {
            // header
            if(json.hasOwnProperty('header'))
                this.header = json.header;

            // left
            if(json.hasOwnProperty('left'))
                this.left = json.left;

            // information
            if(json.hasOwnProperty('information'))
                this.information = new DaoInformation(json.information);

            // notice
            if(json.hasOwnProperty('bbs')) {
                this.bbs = [];
                (json.bbs || []).forEach((bbs) => {
                    /** @type DaoBBSFile[]*/
                    const files = [];
                    (bbs.files || []).forEach((file) => {
                        files.push(new DaoBBSFile(file));
                    });
                    bbs.files = files;
                    this.bbs.push(new DaoBBS(bbs));
                });
            }

            // channel
            if(json.hasOwnProperty('channel')) {
                const channelLists = [];
                (json.channel.lists || []).forEach(channel_lists => {
                    channelLists.push(new DaoChannelRecommand(channel_lists));
                });
                json.channel.lists = channelLists;
                this.channel = json.channel;
            }

            // chart
            if(json.hasOwnProperty('chart')) {
                this.chart = {};
                for(let chartType in json.chart) {
                    if(json.chart.hasOwnProperty(chartType)) {
                        const charts = [];
                        const chartChannels = json.chart[chartType] || [];
                        chartChannels.forEach(chartChannel => {
                            charts.push(new DaoChannel(chartChannel));
                        });
                        this.chart[chartType] = charts;
                    }
                }

                this.brandlogo = json.chart.hasOwnProperty('logo') ? json.chart.logo : null;
            }

            // pick
            if(json.hasOwnProperty('pick')) {
                (json.pick || []).forEach(pickLists => {
                    pickLists.lists = new DaoChannel(pickLists.lists);
                });
                this.pick = json.pick;
            }

            // history
            if(json.hasOwnProperty('history')) {
                this.history = [];
                (json.history || []).forEach(history => {
                    this.history.push(new DaoChannel(history));
                });
            }
        }
        return this;
    }

    /**
     * 신규 공지
     * @returns {number}
     */
    get bbsNew() {
        let counts = 0;
        (this.bbs || []).forEach(bbs => {
            const dateGap = new Date().getTime() - bbs.date.getTime();
            const isNew = dateGap - (rd.notice_new * 86400 * 1000) < 0;
            if(isNew) counts++;
        });
        return counts;
    }

    /**
     *
     * @param history {DaoChannel}
     */
    addHistory(history) {
        if(!this.history.length) this.history = [];
        if(this.history.length === rd.history_limit) {
            this.history.splice(-1, 1);
        }
        this.history.unshift(history);
    }
}

export default DaoMain;


// WEBPACK FOOTER //
// ./src/modules/dao/main.js